import './CarModelGreenFutureBlock.scss';
import React from 'react';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
export default function CarModelGreenFutureBlock({ fields }) {
  return (
    <div className={'container car-model-green-block'}>
      <div className={'wrapper'}>
        <div className={'imageWrapper'} data-aos="fade-up">
          <Image field={fields?.image} alt={fields?.description?.value} fill />
        </div>
        <div className={'content'}>
          <div>
            <h3 className={'title'} data-aos="fade-up">
              <RichText field={fields?.titleText} />
            </h3>
            <p className={'text'} data-aos="fade-up">
              {fields?.description?.value}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
